export default __webpack_public_path__ + "static/bg-light-illustration-8b25249ef522b5d242aa2bd637d7a3cb.png";